import { render, staticRenderFns } from "./TaskListOrders.vue?vue&type=template&id=521e8b3a"
import script from "./TaskListOrders.vue?vue&type=script&lang=js"
export * from "./TaskListOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports